<script type="text/ecmascript-6">
    export default {
        props: {
            generator: Object,
            readOnly: Boolean,
        },
        data() {
            return {
                selectedOptions: [],
            }
        },
        created() {
            this.selectedOptions = this.generator.selected;
        },
        methods: {
            toggleAll() {
                if (this.allChecked) {
                    this.selectedOptions = [];
                } else {
                    this.selectedOptions = _.keys(this.generator.options);
                }
            },
            options() {
                if (this.generator.isAdmin && !this.readOnly) {
                    return this.generator.options;
                } else {
                    let options = {};

                    _.each(this.generator.selected, (id) => {
                        let value = this.generator.options[id];

                        if (value) {
                            options[id] = value;
                        }
                    });

                    return options;
                }
            },
            update() {
                axios.put(Scoop.baseUrl + '/api/policyGenerator', {
                    class: this.generator.class,
                    user_id: this.generator.user.id,
                    selected: this.selectedOptions,
                }).then(() => {
                    toastr.success('Successfully saved');
                });
            }
        },
        computed: {
            showCheckAll() {
                if (_.size(this.options()) === 1) {
                    return false;
                }

                return this.generator.isAdmin && this.generator.allowCheckAll;
            },
            allChecked() {
                return this.selectedOptions.length == _.keys(this.generator.options).length;
            },
        },
        watch: {
            selectedOptions() {
                if (this.selectedOptions != this.generator.selected) {
                    this.update();
                }
            }
        },
    }
</script>
<template>
    <div class="form-group" v-if="Object.keys(options()).length > 0">
        <label class="col-sm-4 control-label">{{ generator.displayName }}</label>
        <div class="col-sm-4">
            <div class="checkbox" v-if="showCheckAll && !readOnly">
                <label>
                    <input type="checkbox" @click="toggleAll" :checked="allChecked">
                    <strong>Check all</strong>
                </label>
            </div>
            <div class="checkbox" v-for="(option, id) in options()">
                <label>
                    <input type="checkbox" :value="id" v-model="selectedOptions"
                           :disabled="!generator.isAdmin || readOnly">
                    <span>{{ option }}</span>
                </label>
            </div>
        </div>
    </div>
</template>
